<template>
  <div>
    <Banner :with-bias-banner="true" />
    <div style="position: relative; background-color: black; height: 54px;">
      <BiasBanner />
    </div>
    <section class="mobile-licenses">
      <h2>BIAS FX 移动版授权</h2>
      <hr>
      <table>
        <tr>
          <th
            scope="col"
            colspan="1"
          />
          <th scope="col">
            免费版<br><span>免费</span>
          </th>
          <th scope="col">
            入门版<br><span>¥68</span>
          </th>
          <th scope="col">
            基础版<br><span>¥128</span>
          </th>
          <th scope="col">
            终极版<br><span>¥388</span>
          </th>
        </tr>
        <tr>
          <td>音箱</td>
          <td>2</td>
          <td>5</td>
          <td>12</td>
          <td>20</td>
        </tr>
        <tr>
          <td>效果器</td>
          <td>7</td>
          <td>15</td>
          <td>30</td>
          <td>81</td>
        </tr>
        <tr>
          <td>厂家预置音色</td>
          <td>6</td>
          <td>18</td>
          <td>50</td>
          <td>74</td>
        </tr>
        <tr>
          <td>调音表</td>
          <td class="circle">
            <span />
          </td>
          <td class="circle">
            <span />
          </td>
          <td class="circle">
            <span />
          </td>
          <td class="circle">
            <span />
          </td>
        </tr>
        <tr>
          <td>节拍器</td>
          <td class="circle">
            <span />
          </td>
          <td class="circle">
            <span />
          </td>
          <td class="circle">
            <span />
          </td>
          <td class="circle">
            <span />
          </td>
        </tr>
        <tr>
          <td>现场模式</td>
          <td class="circle">
            <span />
          </td>
          <td class="circle">
            <span />
          </td>
          <td class="circle">
            <span />
          </td>
          <td class="circle">
            <span />
          </td>
        </tr>
        <tr>
          <td>音色云</td>
          <td class="circle">
            <span />
          </td>
          <td class="circle">
            <span />
          </td>
          <td class="circle">
            <span />
          </td>
          <td class="circle">
            <span />
          </td>
        </tr>
        <tr>
          <td>双信号线路</td>
          <td>-</td>
          <td class="circle">
            <span />
          </td>
          <td class="circle">
            <span />
          </td>
          <td class="circle">
            <span />
          </td>
        </tr>
        <tr>
          <td>BIAS AMP 集成</td>
          <td>-</td>
          <td>-</td>
          <td class="circle">
            <span />
          </td>
          <td class="circle">
            <span />
          </td>
        </tr>
        <tr>
          <td>MIDI 支持</td>
          <td>-</td>
          <td>-</td>
          <td class="circle">
            <span />
          </td>
          <td class="circle">
            <span />
          </td>
        </tr>
        <tr>
          <td>全局控制</td>
          <td>直接输出</td>
          <td>直接输出</td>
          <td>
            直接输出<br>
            前置放大<br>
            一体箱<br>
            分体箱<br>
          </td>
          <td>
            直接输出<br>
            前置放大<br>
            一体箱<br>
            分体箱<br>
          </td>
        </tr>
        <tr>
          <td>扩展包</td>
          <td>-</td>
          <td>-</td>
          <td>-</td>
          <td class="circle">
            <span />
          </td>
        </tr>
      </table>
    </section>
    <section class="expansion">
      <h2>扩展包</h2>
      <hr>
      <table>
        <tr>
          <td>模拟效果基础包<br><span>¥68</span></td>
          <td>9 款效果器</td>
        </tr>
        <tr>
          <td>60年代经典效果包<br><span>¥68</span></td>
          <td>9 款效果器</td>
        </tr>
        <tr>
          <td>强力效果包<br><span>¥68</span></td>
          <td>11 款效果器</td>
        </tr>
        <tr>
          <td>原声效果包<br><span>¥68</span></td>
          <td>
            2 款音箱<br>
            4 款效果器
          </td>
        </tr>
        <tr>
          <td>贝斯效果包<br><span>¥68</span></td>
          <td>7 款效果器</td>
        </tr>
        <tr>
          <td>录音棚机架包<br><span>¥68</span></td>
          <td>5 款效果器</td>
        </tr>
        <tr>
          <td>金属音色签名包<br><span>¥68</span></td>
          <td>
            6 款音箱<br>
            6 款效果器
          </td>
        </tr>
      </table>
    </section>
    <section class="footer-link">
      <div>
        <img src="@/assets/bias-fx-mobile/biasfx-icon@2x.png">
      </div>
      <div>
        <h3>BIAS FX <span>移动版</span></h3>
        <p>完整的 iOS 吉他音箱和效果器</p>
      </div>
    </section>
    <section class="footer-link">
      <a href="https://itunes.apple.com/us/app/bias-fx-guitar-amp-effects/id937685528" />
    </section>
    <footer-weixin />
    <footer-common />
  </div>
</template>

<script>
import BiasBanner from '@/components/bias-banner'
import Banner from '@/components/banner'

import FooterWeixin from '@/components/footer-weixin'
import FooterCommon from '@/components/footer-common'

import store from '@/store'

export default {
  name: 'Index',
  store,
  components: {
    Banner, FooterWeixin, FooterCommon, BiasBanner
  },
  data () {
    return {
    }
  },
  computed: {},
  mounted: function () {},
  methods: {
  }
}
</script>

<style scoped>
.footer-link {
  display: flex;
  justify-content: center;
  margin-bottom: 100px;
}
.footer-link > div {
  display: inline-block;
}
.footer-link > div:nth-of-type(2) {
  margin-left: 21px;
}
.footer-link img {
  width: 76px;
  height: 76px;
}
.footer-link h3 {
  font-size: 30px;
  font-weight: 900;
  font-family: Roboto;
}
.footer-link h3, .footer-link p {
  color: white;
  margin-top: 0;
  margin-bottom: 0;
}

.footer-link span {
  font-weight: 300;
}
.footer-link a {
  background-image: url(../assets/app-store.svg);
  width: 169px;
  height: 62px;
  background-size: cover;
}

section {
  width: 40%;
  margin: 0 auto;
}
table {
  text-align: center;
  border-collapse: collapse;
  color: white;
  width: 100%;
}
table td:first-of-type {
  text-align: left;
  font-weight: 700;
}
.mobile-licenses table tr:first-of-type {
  border-bottom: unset;
}
table td, th {
  padding: 8px;
}
table tr {
  border-bottom: 1px solid rgba(255, 255, 255, .5);
}
table td {
  font-size: 16px;
}
table th {
  font-size: 24px;
  font-weight: 300;
}
table th span, .expansion table td span {
  font-size: 18px;
  color: #fdcb76;
}
.expansion table td span {
  font-weight: 300;
}
table .circle span {
  margin: 0 auto;
  width: 8px;
  height: 8px;
  background-color: #c1b58d;
  border-radius: 4px;
  display: block;
}
.expansion table td:nth-of-type(2) {
  text-align: left;
}
.bias-banner {
  position: relative;
}
.mobile-licenses, .expansion {
  margin-top: 104px;
  margin-bottom: 104px;
}
h2 {
  text-align: center;
  color: white;
}
hr {
  border: 1px solid white;
}

@media screen and (max-width: 768px) {
  section {
    width: 100%;
    margin: 0 auto;
  }
  table td {
    font-size: 12px;
  }
  table th {
    font-size: 18px;
    font-weight: 300;
  }
  table th span, .expansion table td span {
    font-size: 12px;
    color: #fdcb76;
  }
  table td, th {
    padding: 6px;
  }
}

.daws tr {
  border-bottom: 0;
}
.daws td {
  padding: 0;
}

</style>



// WEBPACK FOOTER //
// src/pages/bias-fx-mobile-spec.vue